module.exports = __webpack_public_path__ + "static/media/poderosaImagen-min.44dd00f3.jpg";